import { Action } from 'redux';

export enum DataTreeTypes {
  LOAD_DATABASES = 'data_tree/load-databases',
  LOADING_DATABASES = 'data_tree/loading-databases',
  LOADED_DATABASES = 'data_tree/loaded-databases',
  LOADING_DATABASES_FAILED = 'data_tree/loading-databases-failed',

  LOAD_SCHEMAS = 'data_tree/load-schemas',
  LOADING_SCHEMAS = 'data_tree/loading-schemas',
  LOADED_SCHEMAS = 'data_tree/loaded-schemas',
  LOADING_SCHEMAS_FAILED = 'data_tree/loading-schemas-failed',

  LOAD_TABLES = 'data_tree/load-tables',
  LOADING_TABLES = 'data_tree/loading-tables',
  LOADED_TABLES = 'data_tree/loaded-tables',
  LOADING_TABLES_FAILED = 'data_tree/loading-tables-failed',

  LOAD_COLUMNS = 'data_tree/load-columns',
  LOADING_COLUMNS = 'data_tree/loading-columns',
  LOADED_COLUMNS = 'data_tree/loaded-columns',
  LOADING_COLUMNS_FAILED = 'data_tree/loading-columns-failed',

  LOAD_SELECT_STAR = 'data_tree/load_select_star',
  LOADING_SELECT_STAR = 'data_tree/loading_select_star',
  LOADED_SELECT_STAR = 'data_tree/loaded_select_star',
  LOADING_SELECT_STAR_FAILED = 'data_tree/loading_select_star_failed',

  SET_HIDDEN_NODES = 'data_tree/set_hidden_nodes'
}

export type NodePath = number[];

// Databases as initial tree

export interface ILoadDatabases extends Action {
  type: DataTreeTypes.LOAD_DATABASES
}

export interface ILoadingDatabases extends Action {
  type: DataTreeTypes.LOADING_DATABASES;
}

export interface ILoadedDatabases extends Action {
  type: DataTreeTypes.LOADED_DATABASES;
  payload: any;
}

export interface ILoadingDatabasesFailed extends Action {
  type: DataTreeTypes.LOADING_DATABASES_FAILED;
}

// Schemas

export interface ILoadSchemas extends Action {
  type: DataTreeTypes.LOAD_SCHEMAS;
  payload: {
    databaseId: string | number;
  }
}

export interface ILoadingSchemas extends Action {
  type: DataTreeTypes.LOADING_SCHEMAS;
}

export interface ILoadedSchemas extends Action {
  type: DataTreeTypes.LOADED_SCHEMAS;
  payload: any;
}

export interface ILoadingSchemasFailed extends Action {
  type: DataTreeTypes.LOADING_SCHEMAS_FAILED;
}

// Tables

export interface ILoadTables extends Action {
  type: DataTreeTypes.LOAD_TABLES;
  payload: {
    databaseId: number;
    schemaName: string;
  }
}

export interface ILoadingTables extends Action {
  type: DataTreeTypes.LOADING_TABLES;
}

export interface ILoadedTables extends Action {
  type: DataTreeTypes.LOADED_TABLES;
  payload: any;
}

export interface ILoadingTablesFailed extends Action {
  type: DataTreeTypes.LOADING_TABLES_FAILED;
}

// Columns

export interface ILoadColumns extends Action {
  type: DataTreeTypes.LOAD_COLUMNS;
  payload: {
    databaseId: number;
    tableName: string;
    schemaName: string;
  }
}

export interface ILoadingColumns extends Action {
  type: DataTreeTypes.LOADING_COLUMNS;
}

export interface ILoadedColumns extends Action {
  type: DataTreeTypes.LOADED_COLUMNS;
  payload: any;
}

export interface ILoadingColumnsFailed extends Action {
  type: DataTreeTypes.LOADING_COLUMNS_FAILED;
}

export interface ILoadSelectStarAction extends Action {
  type: DataTreeTypes.LOAD_SELECT_STAR;
  payload: {
    database: string,
    schema: string,
    table: string
  }
}

export interface ILoadingSelectStarAction extends Action {
  type: DataTreeTypes.LOADING_SELECT_STAR;
}

export interface ILoadedSelectStarAction extends Action {
  type: DataTreeTypes.LOADED_SELECT_STAR;
  payload: any
}

export interface ILoadingSelectStarFailedAction extends Action {
  type: DataTreeTypes.LOADING_SELECT_STAR_FAILED;
}

export interface ISetHiddenNodesAction extends Action {
  type: DataTreeTypes.SET_HIDDEN_NODES;
  payload: string[];
}

// Functions to create actions

export function loadDatabases(): ILoadDatabases {
  return {
    type: DataTreeTypes.LOAD_DATABASES
  }
}

export function loadingDatabases(): ILoadingDatabases {
  return {
    type: DataTreeTypes.LOADING_DATABASES
  }
}

export function loadedDatabases(result: any): ILoadedDatabases {
  return {
    type: DataTreeTypes.LOADED_DATABASES,
    payload: result
  }
}

export function loadingDatabasesFailed(): ILoadingDatabasesFailed {
  return {
    type: DataTreeTypes.LOADING_DATABASES_FAILED
  }
}

// Schemas

export function loadSchemas(databaseId: string | number): ILoadSchemas {
  return {
    type: DataTreeTypes.LOAD_SCHEMAS,
    payload: {
      databaseId,
    }
  }
}

export function loadingSchemas(): ILoadingSchemas {
  return {
    type: DataTreeTypes.LOADING_SCHEMAS
  }
}

export function loadedSchemas(result: any): ILoadedSchemas {
  return {
    type: DataTreeTypes.LOADED_SCHEMAS,
    payload: result
  }
}

export function loadingSchemasFailed(): ILoadingSchemasFailed {
  return {
    type: DataTreeTypes.LOADING_SCHEMAS_FAILED
  }
}

// Tables

export function loadTables(databaseId: number, schemaName: string): ILoadTables {
  return {
    type: DataTreeTypes.LOAD_TABLES,
    payload: {
      databaseId,
      schemaName,
    }
  }
}

export function loadingTables(): ILoadingTables {
  return {
    type: DataTreeTypes.LOADING_TABLES
  }
}

export function loadedTables(result: any): ILoadedTables {
  return {
    type: DataTreeTypes.LOADED_TABLES,
    payload: result
  }
}

export function loadingTablesFailed(): ILoadingTablesFailed {
  return {
    type: DataTreeTypes.LOADING_TABLES_FAILED
  }
}

// Columns

export function loadColumns(databaseId: number, tableName: string, schemaName: string): ILoadColumns {
  return {
    type: DataTreeTypes.LOAD_COLUMNS,
    payload: {
      databaseId,
      tableName,
      schemaName,
    }
  }
}

export function loadingColumns(): ILoadingColumns {
  return {
    type: DataTreeTypes.LOADING_COLUMNS
  }
}

export function loadedColumns(result: any): ILoadedColumns {
  return {
    type: DataTreeTypes.LOADED_COLUMNS,
    payload: result
  }
}

export function loadingColumnsFailed(): ILoadingColumnsFailed {
  return {
    type: DataTreeTypes.LOADING_COLUMNS_FAILED
  }
}

export function loadSelectStarData(database: string, schema: string, table: string): ILoadSelectStarAction {
  return {
    type: DataTreeTypes.LOAD_SELECT_STAR,
    payload: {
      database,
      schema,
      table,
    },
  };
}

export function loadingSelectStarData(): ILoadingSelectStarAction {
  return {
    type: DataTreeTypes.LOADING_SELECT_STAR
  }
}

export function loadedSelectStarData(result: any): ILoadedSelectStarAction {
  return {
    type: DataTreeTypes.LOADED_SELECT_STAR,
    payload: result,
  };
}

export function loadingSelectStarDataFiled(): ILoadingSelectStarFailedAction {
  return {
    type: DataTreeTypes.LOADING_SELECT_STAR_FAILED
  }
}

export function setHiddenNodes(data:string[]): ISetHiddenNodesAction {
  return {
    type: DataTreeTypes.SET_HIDDEN_NODES,
    payload: data
  }
}

export type DataTreeAction =
  ILoadDatabases |
  ILoadingDatabases |
  ILoadedDatabases |
  ILoadingDatabasesFailed |
  ILoadSchemas |
  ILoadingSchemas |
  ILoadedSchemas |
  ILoadingSchemasFailed |
  ILoadTables |
  ILoadingTables |
  ILoadedTables |
  ILoadingTablesFailed |
  ILoadColumns |
  ILoadingColumns |
  ILoadedColumns |
  ILoadingColumnsFailed |
  ILoadSelectStarAction |
  ILoadingSelectStarAction |
  ILoadedSelectStarAction |
  ISetHiddenNodesAction |
  ILoadingSelectStarFailedAction;
